export const ADMIN_ROUTE = '/admin'
export const LOGIN_ROUTE = '/login'
export const REGISTER_ROUTE = '/register'

/** Текст ошибки API при невалидном JWT (совпадает с `Constants.JWT_INVALID` на бэкенде). */
export const API_JWT_INVALID_SUBSTRING = 'Токен недействителен'

/** Глобальное событие: сессия недействительна — слушает `ErrorHandler`. */
export const AUTH_EXPIRED_EVENT = 'lutica-auth-expired'
export const PROFILE_ROUTE = '/profile'

export const ORDER_PLACING_ROUTE = '/order-placing'

export const FORGOT_PASSWORD_ROUTE = '/forgot-password'
export const LOGOUT_ROUTE = '/logout'
export const CART_ROUTE = '/cart'
/** Главная: карусель, доставка, ссылка в каталог. */
export const CATALOG_ROUTE = '/'
/** Только список товаров по категориям. */
export const SHOP_ROUTE = '/catalog'

/** Сколько последних по id товаров показывать на главной (2 ряда по 4 на широком экране). */
export const HOME_RECENT_ITEMS = 8
/** Размер порции для бесконечной ленты на странице категории. */
export const CATEGORY_INFINITE_PAGE_SIZE = 12

/** URL страницы товаров одной категории. */
export function shopCategoryPath(categoryTitle) {
    return `${SHOP_ROUTE}/${encodeURIComponent(categoryTitle)}`
}

/** Единая ширина и отступы для шапки, контента и подвала (7xl — чуть шире, чтобы стабильно влезали 4 карточки в сетке). */
export const LAYOUT_SHELL_CLASS = 'mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-10'

/** Сетка карточек товара: 2 колонки на телефоне, 4 от `lg` (см. `ItemCard` без фикс. max-width). */
export const SHOP_ITEM_GRID_CLASS =
    'grid grid-cols-2 gap-x-3 gap-y-6 sm:gap-x-4 lg:grid-cols-4 lg:gap-x-5 lg:gap-y-8'

export const ORDERS_ROUTE = '/orders'
export const ITEM_ROUTE = '/items'
export const PRIVACY_ROUTE = '/privacy'

/** Возврат с оплаты (YooKassa `return_url` и навигация) — `?…=1` усиливает опрос статуса на странице заказа. */
export const ORDER_PAYMENT_RETURN_PARAM = 'paymentReturn'
export const ORDER_PAYMENT_RETURN_VALUE = '1'

/** Контакт для обращений (дублирует контакт в политике). */
export const CONTACT_EMAIL = 'lutica.candle.shop@gmail.com'

/** Ссылка на Telegram; задайте в `.env`: REACT_APP_TELEGRAM_URL=https://t.me/your_channel */
export const TELEGRAM_URL = process.env.REACT_APP_TELEGRAM_URL || ''

/** Синхронно с бэкендом `Constants.DEFAULT_PAGE_SIZE` (основной список). */
export const DEFAULT_PAGE_SIZE = 20
/** Каталог: сколько товаров на странице при группировке по категориям. */
export const CATALOG_PAGE_SIZE = 48
/** Админка: один запрос списков для таблиц и метрик (при росте — отдельные отчёты). */
export const ADMIN_LIST_PAGE_SIZE = 2000
/** Админка: размер страницы для таблицы заказов (отдельно от items, чтобы не тянуть тысячи строк). */
export const ADMIN_ORDERS_PAGE_SIZE = 20

export const ROLE_ADMIN = 'ROLE_ADMIN'
export const ROLE_USER = 'ROLE_USER'

/** Ключи — как в БД / OrderResponse.status (CREATED, PAID, …). `tw` — классы Tailwind для бейджа. */
export const ORDER_STATUS_DICTIONARY = {
    CANCELED: {
        bg: 'danger',
        translation: 'Отменён',
        tw: 'rounded-full px-2.5 py-0.5 text-xs font-medium bg-red-100 text-red-800',
    },
    CREATED: {
        bg: 'secondary',
        translation: 'Создан',
        tw: 'rounded-full px-2.5 py-0.5 text-xs font-medium bg-stone-200 text-bark-800',
    },
    PAID: {
        bg: 'primary',
        translation: 'Оплачен',
        tw: 'rounded-full px-2.5 py-0.5 text-xs font-medium bg-pine-100 text-pine-900',
    },
    SHIPPED: {
        bg: 'primary',
        translation: 'Отправлен',
        tw: 'rounded-full px-2.5 py-0.5 text-xs font-medium bg-pine-200 text-pine-900',
    },
    DELIVERED: {
        bg: 'success',
        translation: 'Доставлен',
        tw: 'rounded-full px-2.5 py-0.5 text-xs font-medium bg-pine-700 text-white',
    },
}

const STATUS_FALLBACK_TW =
    'rounded-full px-2.5 py-0.5 text-xs font-medium bg-stone-200 text-bark-700';

/** Приводит код статуса к ключу словаря (CREATED, CANCELED, …). */
export function normalizeOrderStatusCode(status) {
    if (status == null || status === '') return ''
    const u = String(status).trim().toUpperCase()
    if (u === 'CANCELLED') return 'CANCELED'
    return u
}

export function orderStatusPresentation(status) {
    const key = normalizeOrderStatusCode(status)
    return (
        ORDER_STATUS_DICTIONARY[key] || {
            bg: 'secondary',
            translation: status ? String(status) : '—',
            tw: STATUS_FALLBACK_TW,
        }
    );
}

/** Опции для фильтра по статусу заказа в админ-таблице (синхронно с бэкендом `DbOrderStatus`). */
export const ORDER_STATUS_FILTER_OPTIONS = [
    {value: '', label: 'Все статусы'},
    {value: 'CREATED', label: 'Создан'},
    {value: 'PAID', label: 'Оплачен'},
    {value: 'SHIPPED', label: 'Отправлен'},
    {value: 'DELIVERED', label: 'Доставлен'},
    {value: 'CANCELED', label: 'Отменён'},
];

/** Ответы checkPayment (тело): PAID — оплачен; canceled — отмена у провайдера. */
export const PAYMENT_CHECK_PAID = 'PAID'
export const PAYMENT_CHECK_CANCELED = 'canceled'
/** В провайдере ещё pending / waiting_for_capture, заказ CREATED */
export const PAYMENT_CHECK_PENDING = 'PENDING'
/** Терминальный статус в провайдере, не успех и не ожидание (см. бэкенд) */
export const PAYMENT_CHECK_ABNORMAL = 'PAYMENT_ABNORMAL'

/** Как в `OrderDeliveryType` на бэкенде. */
export const ORDER_DELIVERY_MANUAL = 'MANUAL'
export const ORDER_DELIVERY_YANDEX_PICKUP = 'YANDEX_PICKUP'

/** Подписи способа доставки для UI. */
export function orderDeliveryPresentation(deliveryType) {
    if (deliveryType === ORDER_DELIVERY_YANDEX_PICKUP) {
        return {label: 'Яндекс.Доставка (ПВЗ)', short: 'ПВЗ'}
    }
    return {label: 'По договорённости', short: 'Адрес'}
}

/** Легаси: раньше перед текстом ПВЗ писали эту метку в `address`. Сейчас в БД может ещё встречаться. */
export const YANDEX_PVZ_ADDRESS_PREFIX = 'Яндекс.Доставка (ПВЗ):'

/** Снять легаси-метку с начала адреса; если метки нет — вернуть строку без изменений. */
export function stripLegacyYandexPvzPrefix(addr) {
    const a = (addr != null && String(addr).trim()) || ''
    if (!a.startsWith(YANDEX_PVZ_ADDRESS_PREFIX)) {
        return a
    }
    return a.slice(YANDEX_PVZ_ADDRESS_PREFIX.length).trim()
}